// utils/passwordPolicy.js
//
// Réplica de la política de contraseñas del backend
// (dap-backend/utils/passwordPolicy.js). Sirve únicamente para dar feedback en
// vivo al usuario: la validación que vale es la del servidor. Si se cambia una
// regla acá, hay que cambiarla también allá.

export const MIN_LENGTH = 10;
export const MAX_BYTES = 72;

const COMMON_PASSWORDS = [
  "password1!",
  "password123",
  "passw0rd!",
  "contrasena1!",
  "contraseña1!",
  "qwerty123!",
  "abcd1234!",
  "admin1234!",
  "aa1234567!",
  "1q2w3e4r5t!",
];

function byteLength(value) {
  return new TextEncoder().encode(value).length;
}

export const PASSWORD_RULES = [
  {
    key: "length",
    label: "password.rules.length",
    test: (password) => password.length >= MIN_LENGTH,
  },
  {
    key: "lowercase",
    label: "password.rules.lowercase",
    test: (password) => /\p{Ll}/u.test(password),
  },
  {
    key: "uppercase",
    label: "password.rules.uppercase",
    test: (password) => /\p{Lu}/u.test(password),
  },
  {
    key: "digit",
    label: "password.rules.digit",
    test: (password) => /\p{N}/u.test(password),
  },
  {
    key: "symbol",
    label: "password.rules.symbol",
    test: (password) => /[^\p{L}\p{N}]/u.test(password),
  },
  {
    key: "maxBytes",
    label: "password.rules.maxBytes",
    test: (password) => byteLength(password) <= MAX_BYTES,
  },
  {
    key: "trim",
    label: "password.rules.trim",
    test: (password) => password === password.trim(),
  },
  {
    key: "common",
    label: "password.rules.common",
    test: (password) => !COMMON_PASSWORDS.includes(password.toLowerCase()),
  },
  {
    key: "personalData",
    label: "password.rules.personalData",
    test: (password, context = {}) => {
      const lowered = password.toLowerCase();
      const terms = [];

      if (context.nombre) {
        terms.push(...String(context.nombre).toLowerCase().split(/\s+/));
      }

      if (context.mail) {
        const mail = String(context.mail).toLowerCase();
        terms.push(mail, mail.split("@")[0]);
      }

      return !terms.some((term) => term.length >= 4 && lowered.includes(term));
    },
  },
];

/**
 * @returns {Array<{key: string, label: string, ok: boolean}>}
 */
export function checkPassword(password, context = {}) {
  const value = typeof password === "string" ? password : "";

  return PASSWORD_RULES.map((rule) => ({
    key: rule.key,
    label: rule.label,
    ok: value.length > 0 && rule.test(value, context),
  }));
}

export function isPasswordValid(password, context = {}) {
  return checkPassword(password, context).every((rule) => rule.ok);
}
